<template>
  <v-card class="ma-2">
    <v-card-title>修改供應商</v-card-title>
    <v-card-text>
      <v-divider />
      <merchant-form
        v-bind="form"
        :loading="loading"
        @submit="submit"
      ></merchant-form>
    </v-card-text>
  </v-card>
</template>

<script>
import api from '@/api';
import Swal from 'sweetalert2';
import MerchantForm from './Form.vue';

const { merchant } = api;

async function getMerchant(merchantId) {
  const { status, data } = await api.merchant.get(merchantId);
  return status === 1 ? data : null;
}

export default {
  components: { MerchantForm },
  props: {
    merchantId: {
      type: [Number, String],
      require: true,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        merchantCode: null,
        merchantName: null,
        categoryId: null,
        link: null,
        merchantPic: null,
        displayType: 1,
        voucherGenerationMethod: null,
        swapOutServiceFee: null,
        swapOutServiceFeePercentage: null,
        pointBackPercentage: null,
        additionalParameters: null,
        canUserChangeStatusOfVoucher: false,
        email: null,
        notAvailablePaymentMethods: null,
      },
    };
  },
  methods: {
    setForm(form) {
      this.form = form;
    },
    async submit(form) {
      if (form) {
        this.loading = true;
        const { status } = await merchant.edit(this.merchantId, form);
        this.loading = false;
        if (status === 1) {
          await Swal.fire({ icon: 'success', title: '修改成功' });
          await this.$router.back();
        }
      }
    },
  },
  async beforeRouteEnter(to, from, next) {
    const { merchantId } = to.params;
    const data = await getMerchant(merchantId);
    next(data ? (vm) => vm.setForm(data) : false);
  },
};
</script>

<style>
</style>
